import {CopyInput} from '../../../components/copy-input';
import edap, {TYPES} from '../edap';
import {COLLABORATE__24} from '../../../components/svg-def';
import React, {Component} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {withTranslationsAsProps} from '../../../components/translations';

export class InviteUrl extends Component {
    static defaultProps = {
        boardId: null,
        desc: '',
        endDate: null,
        error: null,
        fetch: () => {},
        langError: '',
        startDate: null,
        title: '',
        url: ''
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {boardId, fetch} = this.props;
        fetch(boardId);
    }

    onCopyClick = () => {
        const {boardId, endDate, startDate} = this.props;
        edap.copyClick(boardId, endDate, startDate, TYPES.INVITE);
    }

    onCopyUrl = () => {
        const {boardId, endDate, startDate} = this.props;
        edap.copyUrl(boardId, endDate, startDate, TYPES.INVITE);
    }

    onCutUrl = () => {
        const {boardId, endDate, startDate} = this.props;
        edap.cutUrl(boardId, endDate, startDate, TYPES.INVITE);
    }

    render() {
        const {desc, error, isMobile, langError, title, url} = this.props;
        const errorMsg = (error) ? langError : null;
        return (
            <div className="position-relative">
                <h5 className="flex-row">
                    <SVGIcon className="margin-right-2x" markup={COLLABORATE__24} />
                    {title}
                </h5>
                <CopyInput
                    errorMsg={errorMsg}
                    isMobile={isMobile}
                    id="trip-board-invite-url"
                    onCopyClick={this.onCopyClick}
                    onCopyUrl={this.onCopyUrl}
                    onCutUrl={this.onCutUrl}
                    value={url || ''}
                />
                <span className="help-block">{desc}</span>
            </div>
        );
    }
}


export default withTranslationsAsProps({
    'tripboards.invite.desc': 'desc',
    'th.inbox.error.title': 'langError',
    'tripboards.invite.collaborators': 'title'
})(InviteUrl);



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/invite-url.js